/**
 * @generated SignedSource<<1aef065f1bf8e23d4a4fa31976ad4062>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetLinkButtonInPageInput = {
  clientMutationId?: string | null;
  messageDefinitionId: string;
  pageId: string;
  text: string;
  url: string;
};
export type useMessagePageButtonMutations_SetLinkButtonMutation$variables = {
  connections: ReadonlyArray<string>;
  input: SetLinkButtonInPageInput;
};
export type useMessagePageButtonMutations_SetLinkButtonMutation$data = {
  readonly Admin: {
    readonly MessageDefinitions: {
      readonly setLinkButtonInPage: {
        readonly messageDefinition: {
          readonly node: {
            readonly id: string;
          };
        };
      } | null;
    };
  };
};
export type useMessagePageButtonMutations_SetLinkButtonMutation = {
  response: useMessagePageButtonMutations_SetLinkButtonMutation$data;
  variables: useMessagePageButtonMutations_SetLinkButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MessageDefinitionsEdge",
  "kind": "LinkedField",
  "name": "messageDefinition",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageDefinition",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useMessagePageButtonMutations_SetLinkButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageDefinitionsAdminMutationSchema",
            "kind": "LinkedField",
            "name": "MessageDefinitions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "SetLinkButtonInPagePayload",
                "kind": "LinkedField",
                "name": "setLinkButtonInPage",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useMessagePageButtonMutations_SetLinkButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageDefinitionsAdminMutationSchema",
            "kind": "LinkedField",
            "name": "MessageDefinitions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "SetLinkButtonInPagePayload",
                "kind": "LinkedField",
                "name": "setLinkButtonInPage",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "appendEdge",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "messageDefinition",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b9a191ed9c724ce6027c1ee1a488cabf",
    "id": null,
    "metadata": {},
    "name": "useMessagePageButtonMutations_SetLinkButtonMutation",
    "operationKind": "mutation",
    "text": "mutation useMessagePageButtonMutations_SetLinkButtonMutation(\n  $input: SetLinkButtonInPageInput!\n) {\n  Admin {\n    MessageDefinitions {\n      setLinkButtonInPage(input: $input) {\n        messageDefinition {\n          node {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e50a5620a67d3b5ad68f3bb4990c42a3";

export default node;
